import GlobalStyles from '../../global-styles';
import { OpenInNewIcon } from '../../utils/icons';
import {
  Alert, AlertTitle, Box, Button, Grid, Hidden, Typography
} from '../../utils/material-ui-core';

interface ConfirmProps {
  addressResultOutput: AddressResultOutput;
  currentAddress: Address;
  callbackOnClose: () => void;
  useThisAddressButton: boolean;
  callbackOnUseThisAddress: () => void;
  overrideValidationAddress: boolean;
  callbackOnOverrideValidationAddress: () => void;
}

const DisplayAddressResult = ({ addressResultOutput, currentAddress, callbackOnClose, useThisAddressButton, callbackOnUseThisAddress, overrideValidationAddress, callbackOnOverrideValidationAddress }: ConfirmProps) => {
  const globalStyles = GlobalStyles();

  const showAddress = () => {
    if (addressResultOutput.address != null) {
      if (currentAddress !== null) {
        let addressLine = currentAddress.addressline1.trim();

        if (currentAddress.addressline2.trim() !== "") {
          if (addressLine !== "") {
            addressLine += " ";
          }
          addressLine += currentAddress.addressline2.trim();
        }
        const currentAddressInfo = addressLine + " " + currentAddress.locality1 + " " + currentAddress.region1 + " " + currentAddress.postalCode + " " + currentAddress.country.substr(0, 2);

        if (currentAddressInfo.toLowerCase() !== (addressResultOutput.addressLine.trim() + " " + addressResultOutput.cityStatePostalCountry).toLowerCase()) {
          return true;
        }
        return false;
      }

      return true;
    }
    return false;
  };

  const showReplaceButton = () => {
    if (useThisAddressButton && showAddress()) {
      if (addressResultOutput.valid) {
        if (addressResultOutput.autoCorrect || addressResultOutput.errorCodeTagged || !addressResultOutput.sameAddressLine) {
          return true;
        }
      }
    }
    return false;
  };

  const showGoogleButton = () => {
    try {

      let fullAddress = "";

      fullAddress = String(addressResultOutput.addressLine + " " + addressResultOutput.cityStatePostalCountry).trim();

      // if (fullAddress === undefined || fullAddress === null || fullAddress === "") {
      //   fullAddress = String(currentAddress.addressline1 + " " + currentAddress.addressline2 + ' ' + currentAddress.locality1 + " " + currentAddress.region1 + " " + currentAddress.postalCode + " " + currentAddress.country).trim();
      // }

      if (fullAddress !== undefined && fullAddress !== null && fullAddress !== "") {
        return true;
      }
    } catch (e) { }
    return false
  };

  const openGoogle = () => {
    try {

      let fullAddress = String(addressResultOutput.addressLine + " " + addressResultOutput.cityStatePostalCountry).trim();

      if (fullAddress === undefined || fullAddress === null || fullAddress === "") {
        fullAddress = String(currentAddress.addressline1 + " " + currentAddress.addressline2 + ' ' + currentAddress.locality1 + " " + currentAddress.region1 + " " + currentAddress.postalCode + " " + currentAddress.country).trim();
      }

      if (fullAddress !== undefined && fullAddress !== null && fullAddress !== "") {
        const url = "http://google.com/search?q=" + fullAddress;
        window.open(url, "SensorAdminGoogle", "noopener,noreferrer");
      }
    } catch (e) { }
  };

  return (
    <>
      {addressResultOutput.show ? (
        <Alert
          severity={addressResultOutput.valid ? (addressResultOutput.errorCodeTagged ? "warning" : addressResultOutput.autoCorrect ? "error" : addressResultOutput.sameAddressLine ? "success" : "info") : "error"}
          onClose={() => {
            callbackOnClose();
          }}
        >
          <AlertTitle>{!addressResultOutput.valid ? <Typography variant="body2">{addressResultOutput.message}</Typography> : !addressResultOutput.autoCorrect && addressResultOutput.sameAddressLine ? <Typography variant="body2">{addressResultOutput.message}</Typography> : <Typography variant="body2">{addressResultOutput.message}</Typography>}</AlertTitle>

          {addressResultOutput.valid ? (
            <Box>
              <Grid container spacing={1}>
                {showAddress() ? (
                  <>
                    <Grid item xs={12}>
                      Suggested address
                    </Grid>

                    <Grid item>
                      <Typography variant="body2">
                        <b>{addressResultOutput.addressLine}</b>
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Typography variant="body2">
                        <b>{addressResultOutput.cityStatePostalCountry}</b>
                      </Typography>
                    </Grid>
                  </>
                ) : null}
                <Grid item xs={12}>
                  {showReplaceButton() || !addressResultOutput.valid ? (
                    <>
                      <Box p={1}></Box>
                    </>
                  ) : null}

                  <Box display="flex" justifyContent="left" alignItems="center">
                    {showReplaceButton() ? (
                      <Button className={globalStyles.buttonDefault} variant="contained" size="small" onClick={callbackOnUseThisAddress}>
                        {addressResultOutput.errorCodeTagged ? "Override Address" : "Use This Address"}
                      </Button>
                    ) : null}

                    {!addressResultOutput.valid && overrideValidationAddress ? (
                      <Button className={globalStyles.buttonDefault} variant="contained" size="small" onClick={callbackOnOverrideValidationAddress}>
                        Override Validation
                      </Button>
                    ) : null}

                    {(showReplaceButton() || !addressResultOutput.valid) && showGoogleButton() ? (
                      <Hidden only={['xs']}>
                        <Button className={globalStyles.buttonDefault} variant="contained" size="small" onClick={openGoogle}>
                          Google&nbsp;
                          <OpenInNewIcon fontSize="small" />
                        </Button>
                        <Box p={1}><small>Try also in <a href="https://tools.usps.com/zip-code-lookup.htm?byaddress" target='_USPS'>USPS</a> Site</small></Box>
                      </Hidden>
                    ) : null}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Box>
              <Box p={1}></Box>
              <Box display="flex" justifyContent="left" alignItems="center">
                {overrideValidationAddress ? (
                  <>
                    <Button className={globalStyles.buttonDefault} variant="contained" size="small" onClick={callbackOnOverrideValidationAddress}>
                      Override Validation
                    </Button>
                    <Hidden only={['xs']}>
                      {" "}
                      <Button className={globalStyles.buttonDefault} variant="contained" size="small" onClick={openGoogle}>
                        Google&nbsp;
                        <OpenInNewIcon fontSize="small" />
                      </Button>
                      <Box p={1}><small>Try also in <a href="https://tools.usps.com/zip-code-lookup.htm?byaddress" target='_USPS'>USPS</a> Site</small></Box>
                    </Hidden>
                  </>
                ) : null}
              </Box>
              <Box p={1}></Box>
            </Box>
          )}
        </Alert>
      ) : null}
    </>
  );
};

export default DisplayAddressResult;
